var map = {
	"./analtyticsmonza.png": "03e4",
	"./architectural.png": "0dcf",
	"./assisi.png": "4cf6",
	"./autobus.png": "157a",
	"./bogotaendue.png": "51b3",
	"./bogotaesdue.png": "6269",
	"./bogotaestre.png": "2315",
	"./buenosled.png": "9c52",
	"./car.png": "c738",
	"./carsbologna.png": "e137",
	"./christmast.png": "e2ba",
	"./cityanalytics.png": "094b",
	"./cityanalyticscovid19.png": "9365",
	"./cityangra.png": "687b",
	"./citycycle.png": "934f",
	"./coloured.png": "bfbe",
	"./elettrificazionetrasporti.png": "b005",
	"./energyefficiency.png": "303d",
	"./futurosarria.png": "6b1d",
	"./goticaburgos.png": "df57",
	"./illuminazionearchitetturale.png": "a133",
	"./illuminazionepubblica.png": "80fa",
	"./juicelamp.png": "2eab",
	"./limalighting.png": "a313",
	"./mateupa.png": "f3a6",
	"./multifunctional.png": "58a4",
	"./openindex.png": "7c32",
	"./operaio.png": "9ffd",
	"./pasolutions.png": "378a",
	"./quincy.png": "011b",
	"./recharge.png": "2758",
	"./riconoscimentofacciale.png": "eb14",
	"./sanmauropa.png": "9ead",
	"./sicurezzaflorida.png": "300f",
	"./smartcity.png": "4907",
	"./solar_energy.png": "7496",
	"./soluzionismartbuildings.png": "89b2",
	"./spettacololuci.png": "40ff",
	"./stadium.png": "0f00",
	"./temporalperu.png": "ab7a",
	"./trasportipubblici.png": "a7df",
	"./trasportipubblicichile.png": "bc2b",
	"./trellis_sunset.jpeg": "d41e",
	"./turinjuicemedia.png": "bb6d",
	"./vernazzapatrimonio.png": "6c8a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "59d3";